import rem from 'polished/lib/helpers/rem';

const MAX_WIDTH = 1280;

const maxWidthContainer = {
  maxWidth: rem(MAX_WIDTH),
};

export default maxWidthContainer;
